import httpClient from "../apiClient";

import {
  TGetActivityLogsRequest,
  TGetCustomerLogsRequest,
  TResetAccountLogRequest,
} from "./index.types";

export const AGENT_ACTIVITY_LOG_API_URLS = {
  getAgentActivityLog: "agent_activity_log",
  getCustomerLogs: "customer_activity_log",
} as const;
export class AgentActivityLogAPI {
  static getActivityLogsRequest: TGetActivityLogsRequest = (body, signal) =>
    httpClient.post(AGENT_ACTIVITY_LOG_API_URLS.getAgentActivityLog, body, { signal });
  static getCustomerLogsRequest: TGetCustomerLogsRequest = (body) =>
    httpClient.post(AGENT_ACTIVITY_LOG_API_URLS.getCustomerLogs, body);
  static resetAccountLogRequest: TResetAccountLogRequest = (body) =>
    httpClient.post("agent_activity_log/mgm/reset_user", body);
}
